(function ($) {
	// on dom ready, run setUpCounter for each counter
	$(document).ready(function () {
		const $counters = $('.js-selected-counter');

		if (!$counters.length) {
			return;
		}

		$counters.each(setUpCounter);
	});

	function setUpCounter() {
		const $counter = $(this);
		const checkboxName = $counter.attr('data-checkboxes');

		if (!checkboxName) {
			return;
		}

		const $checkboxes = $(`input[name="${checkboxName}"]`);

		$checkboxes.on('change', function (e) {
			e.preventDefault();
			updateCounter($checkboxes, $counter);
		});

		updateCounter($checkboxes, $counter);
	}
	function updateCounter($checkboxes, $counter) {
		const checkedCheckboxes = $checkboxes.filter(':checked');
		const checkedCheckboxesCount = checkedCheckboxes.length;

		if (checkedCheckboxesCount === 0) {
			$counter.text('');
			return;
		}

		$counter.text(` (${checkedCheckboxesCount} selected)`);
	}
})(jQuery);
